import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';
import { AgGridTable } from 'components/tables/AgGridTable';
import { useNavigate } from 'react-router-dom';
import MDButton from 'components/MDButton';
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../redux/slices/modalSlice';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import Search from 'examples/Search';
import { useDebounce } from 'hooks/useDebounce';
import DeleteIcon from 'common/customIcons/delete';
import { openSnackbar } from '../../redux/slices/common';
import { getData } from 'utilities/common';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';
import { deleteMigrateAuthor, migrateAuthor } from '../../redux/apis/blogs';
import EditIcon from "common/customIcons/edit";
import { RemoveRedEye } from '@mui/icons-material';
import defaultProductImage from '../../assets/images/placeholderproduct.svg';

export default function AuthorListing() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const searchTermRef = useRef('');
    const mainGridApiRef = useRef('');
    const gridRefApi = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const pageRef = useRef(0);

    const handleSearch = useDebounce(() => {
        searchFn();
    }, 500);

    const { migrateAuthorsList = {}, fetchingAuthors } = useSelector(state => state.blogs);

    let localUser = getData('login-user-info');
    if (localUser) localUser = JSON.parse(localUser);

    const adminMode = localStorage.getItem('adminsMode') ? JSON.parse(localStorage.getItem('adminsMode')) : null;
    const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

    const canCreate = hasSectionPermission(permissionsForMode, 'Manage Website', 'Create');
    const canView = hasSectionPermission(permissionsForMode, 'Manage Website', 'View Only');
    const canDelete = hasSectionPermission(permissionsForMode, 'Manage Website', 'Delete');
    const canEdit = hasSectionPermission(permissionsForMode, 'Manage Website', 'Edit/Update');

    const showToast = (message, type) => {
        dispatch(openSnackbar({ content: message, color: type === 'success' ? 'success' : 'error', icon: type === 'success' ? 'check' : 'warning' }));
    };
    console.log("searchTermRef", searchTermRef);


    const deleteHandler = (authorId) => {
        dispatch(setModalLoader(true));
        dispatch(deleteMigrateAuthor(authorId))
            .unwrap()
            .then((res) => {
                showToast(res?.message || 'Deleted', 'success');
                dispatch(closeCustomModalDialog());
                searchFn();
                pageRef.current = 0;
            })
            .catch((err) => {
                dispatch(setModalLoader(false));
                showToast(err?.message || 'Delete failed', 'error');
            });
    };

    const columnDefs = [
        {
            headerName: 'Author Profile',
            field: 'image',
            key: 'image',
            suppressMenu: false,
            minWidth: 220,
            cellRenderer: (props) => (
                <img src={props?.value?.url ? props?.value?.url : defaultProductImage} alt={props?.value?.alt} width={30} height={30} />

            )
        },
        {
            headerName: 'Author',
            field: 'name',
            key: 'name',
            suppressMenu: false,
            minWidth: 220,
            cellRenderer: (props) => (
                <Typography variant="caption" display="block" fontWeight="regular" sx={{ cursor: 'pointer', whiteSpace: 'normal', textTransform: 'capitalize' }}>
                    {props?.data?.name || '-'}
                </Typography>
            )
        },
        {
            headerName: 'Description',
            field: 'description',
            suppressMenu: false,
            minWidth: 360,
            flex: 1,
            cellRenderer: (props) => {
                const text = (props?.data?.description || '').replace(/<[^>]*>/g, '');
                const maxLength = 100; // Set your desired max length

                const truncatedText = text.length > maxLength
                    ? text.substring(0, maxLength) + '...'
                    : text;

                return (
                    <Typography variant="caption" display="block" fontWeight="regular" sx={{ whiteSpace: 'normal' }}>
                        {truncatedText}
                    </Typography>
                );
            }
        },
        {
            headerName: 'Action',
            suppressMenu: true,
            minWidth: 100,
            cellRenderer: (props) => (
                <Box className="action-edit w-100 jc-end" display="flex">
                    <IconButton onClick={(e) => {
                        navigate(`/manages/author/${props.data._id}/view`)
                    }} size='small' variant="primary" sx={{ marginLeft: 1 }} color='primary'>
                        <RemoveRedEye width='16px' height='16px' />
                    </IconButton>
                    <IconButton
                        sx={{ marginLeft: 1 }}
                        disabled={!canEdit}
                        onClick={(e) => {
                            e.stopPropagation();
                            onEditClicked(props);
                        }} color='primary' size='small' variant='primary'>
                        <EditIcon width='16px' height='16px' />
                    </IconButton>
                    {/* <IconButton
                        disabled={!canDelete}
                        onClick={(e) => {

                            e.stopPropagation();
                            dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: props?.data?._id, deleteType: 'author' }, modal: 'DELETE_MODAL' }));
                        }}
                        color="error"
                        size="small"
                        variant="primary"
                        sx={{ marginLeft: 1 }}
                    >
                        <DeleteIcon width="16px" height="16px" />
                    </IconButton> */}
                </Box>
            )
        }
    ];

    const onEditClicked = (props) => {
        navigate(`/manages/author/${props?.data?._id}/edit`);
    }

    const getRows = async (params, value) => {
        gridRefApi.current = params;
        let filter = {};
        if (params?.sortModel.length) {
            filter = { ...getSortInfo(params?.sortModel) };
        }
        console.log("data");
        // Make the API call with filters
        dispatch(migrateAuthor({
            skip: 0,
            limit: 20,
            search: searchTermRef.current,
            ...(Array.isArray(value) && value.length > 0 ? { platform: value.join(",") } : {}),
            ...filter,
        }))
            .unwrap().then(res => {
                const { data = [], pagination } = res;

                // Pass the modified data to the grid
                params.successCallback(data, pagination?.total);
                console.log("modifiedBlogs", data);

                // Update the page reference
                pageRef.current = pageRef.current + 20;
            }).catch((err) => {
                params.successCallback([], 0);
            });
    };

    const searchFn = () => {
        const dataSource = { getRows };
        mainGridApiRef.current.ensureIndexVisible(0, null);
        mainGridApiRef.current.setGridOption('datasource', dataSource);
    };

    const onRowClicked = (props) => {
        if (props?.colDef?.headerName !== 'Action') {
            navigate(`/manages/author/${props?.data?._id}/view`);
        }
    };

    const searchHandler = (event) => {
        const { value } = event.target;
        setSearchTerm(value);
        searchTermRef.current = value;
        handleSearch(value);
    };

    useEffect(() => {
        if (mainGridApiRef?.current) {
            if (fetchingAuthors) {
                mainGridApiRef.current.showLoadingOverlay();
            } else if (migrateAuthorsList?.pagination?.total === 0) {
                mainGridApiRef.current.showNoRowsOverlay();
            }
            else {
                mainGridApiRef.current.hideOverlay();
            }
        }
    }, [migrateAuthorsList, fetchingAuthors]);

    return (
        <CommonLayout>
            <Box p={{ xs: 2, sm: 3, lg: 4 }} pb={{ lg: 2 }}>
                <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={2}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="h4">Authors</Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Stack direction="row" justifyContent={{ xs: 'start', sm: 'end' }} flexWrap="wrap" alignItems="stretch" gap={2}>
                            <Search placeholder="Search" label="" value={searchTerm} onChange={searchHandler} />
                            {canCreate && (
                                <MDButton
                                    startIcon={<AddRoundedIcon fontSize="large" />}
                                    sx={{ minWidth: "180px" }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => navigate('/manages/author/add')}
                                >
                                    Add Author
                                </MDButton>
                            )}
                        </Stack>
                    </Grid>
                </Grid>

                {canView && <AgGridTable col={columnDefs} getRows={getRows} mainGridApiRef={mainGridApiRef} isfetchingAuthors={fetchingAuthors} onRowClicked={onRowClicked} style={{ height: '58vh' }} />}
            </Box>
        </CommonLayout>
    );
}